import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/effects/Reveal";
import { BokehParticles } from "@/components/effects/BokehParticles";
import { LightStreaks } from "@/components/effects/LightStreaks";

export const FinalCTA = () => {
  return (
    <section data-testid="final-cta" className="relative py-28 sm:py-36 overflow-hidden">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 50%, rgba(255,46,147,0.14) 0%, transparent 60%)," +
            "radial-gradient(50% 40% at 20% 80%, rgba(24,211,255,0.12) 0%, transparent 60%)," +
            "linear-gradient(180deg, #000, #050507, #000)",
        }}
      />
      <LightStreaks count={4} />
      <BokehParticles count={10} />

      <div className="relative max-w-[1100px] mx-auto px-6 sm:px-10 text-center">
        <Reveal>
          <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-6">— Let’s create</p>
        </Reveal>
        <Reveal delay={120}>
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl leading-[1.02]">
            <span className="text-chrome">Ready to capture your</span>
            <br />
            <span className="italic text-magcyan">next big moment?</span>
          </h2>
        </Reveal>
        <Reveal delay={260}>
          <p className="mt-8 text-white/65 font-body max-w-2xl mx-auto">
            Book WelkomBiz Photography for your next event, business shoot or premium
            visual project. We respond within 24 hours.
          </p>
        </Reveal>
        <Reveal delay={400}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/hire" data-testid="final-cta-hire" className="btn-primary">Hire Us</Link>
            <Link to="/contact" data-testid="final-cta-contact" className="btn-ghost">Contact Us</Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
